export default __webpack_public_path__ + "static/media/Livraison Box2Home3.3feb75fc.svg";